import type { FC } from 'react';
import {
  CheckCircleIcon,
  ExclamationCircleIcon,
  ExclamationTriangleIcon,
} from '@heroicons/react/24/outline';

import { Tooltip } from '@/components/ui/tooltip';
import { ComplianceStatus } from '@/warranty/domain/entities/compliance-status';

type ComplianceStatusIconProps = {
  status: ComplianceStatus;
};

const iconFromComplianceStatus: Record<ComplianceStatus, JSX.Element> = {
  [ComplianceStatus.NO_DATA]: <ExclamationCircleIcon className="size-4" />,
  [ComplianceStatus.COMPLIANT]: <CheckCircleIcon className="size-4" />,
  [ComplianceStatus.NON_COMPLIANT]: (
    <ExclamationTriangleIcon className="size-4" />
  ),
  [ComplianceStatus.AT_RISK]: <ExclamationCircleIcon className="size-4" />,
};

export const tooltipFromComplianceStatus: Record<ComplianceStatus, string> = {
  [ComplianceStatus.NO_DATA]: 'No Data',
  [ComplianceStatus.COMPLIANT]: 'Compliant',
  [ComplianceStatus.NON_COMPLIANT]: 'Non-compliant',
  [ComplianceStatus.AT_RISK]:
    'Currently compliant, but trending toward violation',
};

export const ComplianceStatusIcon: FC<ComplianceStatusIconProps> = ({
  status,
}) => (
  <Tooltip delay content={tooltipFromComplianceStatus[status]}>
    {iconFromComplianceStatus[status]}
  </Tooltip>
);
